import React from 'react'
import Divider from 'material-ui/Divider'
import { getCurrentUserId } from '../helpers'

const getPaidText = course => {
  if (course.cost === 0) {
    return 'Curs gratuit'
  }

  const paymentStatus =
    course &&
    course.payments &&
    course.payments.hasOwnProperty(getCurrentUserId())
      ? course.payments[getCurrentUserId()]
      : ''

  if (paymentStatus) {
    return paymentStatus.receipt
      ? 'Achitat prin depunere numerar la banca'
      : 'Achitat cu cardul online'
  }

  return (
    <div style={{ marginTop: 30 }}>
      <div>
        Pentru participarea la acest curs, va rugam sa aveti in vedere faptul ca
        va trebui sa achitati taxa de inscriere la orice sucursala BRD.
      </div>
      <div>
        Contul in care se va face plata este{' '}
        <strong>RO26 BRDE 360S V983 9117 3600</strong>
      </div>
      <br />
    </div>
  )
}

export const StudentCoursePaymentStatus = ({ course }) => (
  <div>
    <h4>Status plata</h4>
    <span>{getPaidText(course)}</span>
    <Divider style={{ marginTop: 30 }} />
  </div>
)



// WEBPACK FOOTER //
// ./src/components/StudentCoursePaymentStatus.js